import { FilterMenuOption } from "pages/Navigation/Map/FilterMenu";
import { IFilterOptions } from "./types";

export const initialFiltersState: FilterMenuOption[] = [
  { id: '', label: 'Prontas-resposta livres', value: 0, isActive: true },
  { id: '', label: 'Prontas-resposta trabalhando', value: 0, isActive: true },
  { id: '', label: 'Occ. patrimonial', value: 0, isActive: true },
  { id: '', label: 'Occ. veicular', value: 0, isActive: true },
]

export const initialFilterStateList: IFilterOptions = {
  policeman: {
    id: 'policeman', label: 'Prontas-resposta livres', value: 0, isActive: true 
  },
  policemanOnDuty: {
    id: 'policemanOnDuty', label: 'Prontas-resposta trabalhando', value: 0, isActive: true
  },
  occPatrimonial: {
    id: 'occPatrimonial', label: 'Occ. patrimonial', value: 0, isActive: true
  },
  occVehicle: {
    id: 'occVehicle', label: 'Occ. veicular', value: 0, isActive: true
  }
}